module.exports = __webpack_public_path__ + "static/media/person_mbsb_2.9099fcdc.png";